import i18n from 'i18n-js'
import _ from 'lodash'
import Config from '../configs'
import locales from '../locales'

const defaultLocale = Config.get('DEFAULT_LOCALE')
const availableLocales = Config.get('AVAILABLE_LOCALES')

// get locale from location.hash, assume it's the first path segment.
const hash = () => window.location.hash
const locale = () => hash() && hash().length > 1 && _.includes(availableLocales, hash().split('/')[1]) && hash().split('/')[1]

i18n.defaultLocale = defaultLocale
i18n.locale = availableLocales.indexOf(locale()) !== -1 ? locale() : defaultLocale
i18n.translations = locales

class I18n {
  static setLocale(locale) {
    i18n.locale = locale
  }

  static t(str, options) {
    return i18n.t(str, options)
  }

  static currentLocale() {
    return i18n.locale
  }

  static getAvailableLocales() {
    return availableLocales
  }
}

export default I18n



// WEBPACK FOOTER //
// ./src/lib/i18n.js